import { v4 as uuidv4 } from 'uuid';

export function MinicartProductListRemoveButton(props = {}, childrenComponents = []) {
	return {
		componentName: 'MinicartProductListRemoveButton',
		componentId: uuidv4(),
		props: Object.assign(
			{
				variation: 'danger',
				displayMode: 'icon-button',
			},
			props,
		),
		childrenComponents,
	};
}
